/**
 * Kiest uit een reeks Firestore-documenten altijd hetzelfde: laagste
 * `Position`, en bij gelijke stand op `ID`.
 *
 * Firestore levert documenten zonder expliciete sortering in onvoorspelbare
 * volgorde, dus een kale `.limit(1)` pakt de ene keer formulier A en de andere
 * keer formulier B. Sorteren gebeurt hier en niet met `.orderBy()`, omdat een
 * Firestore-orderBy documenten zónder dat veld helemaal uit het resultaat laat
 * vallen.
 *
 * SPIEGEL: functions/personas/pickLowestPosition.js.
 * AI-CONTEXT: See docs/pitfalls.md#database-firestore-orderby-excludes-missing-field
 *
 * @param {Array<{data: () => object}>} docs - Firestore-documenten
 * @returns {object|null} De velden van het gekozen document
 */
const pickLowestPosition = (docs) => {
    const rows = (docs || []).map((doc) => doc.data() || {})
    if (rows.length === 0) return null

    rows.sort((left, right) => {
        const leftPos = Number.isFinite(left.Position) ? left.Position : Number.MAX_SAFE_INTEGER
        const rightPos = Number.isFinite(right.Position) ? right.Position : Number.MAX_SAFE_INTEGER
        if (leftPos !== rightPos) return leftPos - rightPos
        return String(left.ID || '').localeCompare(String(right.ID || ''))
    })

    return rows[0]
}

export default pickLowestPosition
